import { UrlBuilder } from '@/app/ibaraki-region/builders/UrlBuilder';
import { useSearchQuery } from '@/components/EventSearch/hooks';
import { convertToUrlParams } from '@/functions/convertSearchParams';
import { useEffect, useState } from 'react';
import { IBARAKI_REGION_ROUTE } from '../../../constants/region';

export const useIbarakiRegionSearch = (
  regionSetting: IbarakiRegionSetting,
  initialCityDomain: string | undefined,
  initialSearchParams: SearchParams
) => {
  const {
    sort,
    keyword,
    dates,
    categoryId,
    areaId,
    setKeyword,
    setDates,
    setCategoryId,
    setAreaId,
    ref,
    areaEnabled,
    gridItemSm,
    makeSearchParams
  } = useSearchQuery(regionSetting, initialSearchParams);
  const [cityDomain, setCityDomain] = useState<string | null>(
    initialCityDomain ?? null
  );
  const makeSortSearchUrl = (sort: string) => {
    const queryString = convertToUrlParams({
      ...initialSearchParams,
      sort: sort === 'new' ? 'new' : undefined
    }).toString();
    return new UrlBuilder(IBARAKI_REGION_ROUTE)
      .setCityDomain(cityDomain)
      .setQueryString(queryString)
      .setHash('events')
      .build();
  };

  // 絞り込みボタンを押す際はデフォルトのソート順に戻す
  const makeSearchButtonUrl = () => {
    const queryString = convertToUrlParams(
      makeSearchParams(['sort'])
    ).toString();
    return new UrlBuilder(IBARAKI_REGION_ROUTE)
      .setCityDomain(cityDomain)
      .setQueryString(queryString)
      .setHash('events')
      .build();
  };

  // 検索条件をクリアする
  const clearSearch = () => {
    setKeyword('');
    setDates([]);
    setCategoryId(null);
    setCityDomain(null);
    setAreaId(null);
  };

  /**
   * cityが変更された時に、そのcityにareaが含まれない場合、areaを初期化する
   */
  useEffect(() => {
    if (cityDomain && areaId) {
      const city = regionSetting.cities[cityDomain];
      const targetAreas = regionSetting.areas.filter(
        (area) => area.cityId === city.cityId
      );
      if (!targetAreas.some((area) => area.areaId.toString() === areaId)) {
        setAreaId(null);
      }
    }
  }, [
    cityDomain,
    areaId,
    regionSetting.cities,
    regionSetting.areas,
    setAreaId
  ]);

  return {
    sort,
    keyword,
    dates,
    categoryId,
    areaId,
    cityDomain,
    setKeyword,
    setDates,
    setCategoryId,
    setAreaId,
    setCityDomain,
    ref,
    areaEnabled,
    gridItemSm,
    makeSearchButtonUrl,
    makeSortSearchUrl,
    clearSearch
  };
};
